// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.none_eyrvQ {
  display: none;
}

.settingsBg_He7I9 {
  height: 100vh;
  width: 100vw;
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}

@media (width >=950px) {
  .MenuMobileIcon_A9WAh {
    display: none;
  }
}

.shortcut_uSreM {
  font-size: 12px;
  background-color: var(--ececf1-background);
  border-radius: 4px;
  padding: 4px 6px;
  color: var(--818181-color);
  font-weight: 400;
  margin-left: auto;
  margin-right: 14px;
  right: -10px;
  position: relative;
}

.navbarAdmin_mTHm7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: 3;
  /* position: sticky; */
  top: 0;
  gap: 6px;
  background: var(--f5-background);
  color: var(--black-color);
  font-size: 13px;
  padding: 10px 8px;
  box-sizing: border-box;
  height: 50px;

  .name_avW4i {
    display: flex;
    align-items: center;
    font-size: 25px;
    text-transform: capitalize;
    font-weight: 400;
    font-family: "Inter", sans-serif;
    backdrop-filter: blur(10px);
    color: var(--black-color);

    img {
      margin-right: 4px;
    }

    span {
      font-family: "Inter", sans-serif;
      text-transform: uppercase;
    }

    svg {
      color: var(--black-color);
      margin-right: 4px;
    }
  }

  a {
    text-decoration: none;
    position: relative;


    &:last-child {
      border: none;
    }

    &::before {
      content: attr(data-tooltip);
      position: absolute;
      top: calc(120% + 1px);
      left: 50%;
      transform: translateX(-50%);
      padding: 5px 10px;
      background: var(--_000000cc-background);
      color: var(--white-color);
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;

    }

    &::after {
      content: "";
      position: absolute;
      top: calc(100% - 1px);
      left: 50%;
      transform: translateX(-50%);
      border: 5px solid transparent;
      border-bottom-color: var(--_000000cc-background);
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
    }

    &:hover::before,
    &:hover::after {
      opacity: 1;
      visibility: visible;
    }

  }

  .noTooltip_Ot6Rv::before,
  .noTooltip_Ot6Rv::after {
    display: none !important;
    content: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
  }

  .loading_u_fYb {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg,
        transparent 0%,
        var(--_16c098-background) 25%,
        var(--_16c098-background) 75%,
        transparent 100%);
    background-size: 200% 100%;
    animation: loading_u_fYb 2s infinite ease-in-out;
    opacity: 0.8;
    -webkit-animation: loading_u_fYb 2s infinite ease-in-out;

    &.active_ldr9D {
      display: block;
    }
  }
}

@keyframes loading_u_fYb {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

.navbarAdminIcons_FOHC3 {
  display: flex;
  align-items: center;
  gap: 20px;
  /* flex: 1; */
}

@media (width <=950px) {
  .navbarAdminIcons_FOHC3 {
    justify-content: space-between;
  }
}

.plus_v0gVD {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--_10a37f-background);
  outline: none;
  border: none;
  cursor: pointer;
  background: var(--_16c0982e-background);
  font-weight: 550;
  padding: 5px 10px;
  border-radius: 16px;
  line-height: 12px;
  border: 1px solid var(--_16c098-background);
  white-space: nowrap;

}

.profileContainer_F97zR {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 8px;
}

.addIcon_zzoTw {
  height: 18px;
  width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;

  svg {
    fill: rgb(53, 55, 64);
  }
}



.profile_E110D {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: end;
  /* flex: 1; */

  .number_EcOt0 {
    position: relative;


  }

  a {
    cursor: pointer;
    position: relative;
    width: 34px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: var(--ececf1-background);
      border-radius: 50%;
    }

    svg {
      fill: var(--black-color);
      color: var(--black-color);
    }

    &.active_ldr9D {
      svg {
        fill: var(--_16c098-background);
      }
    }
  }

  img {
    width: 20px;
    border-radius: 50%;
  }


}




/* Animación de pulso para llamada */
/* .pulseCall {
  position: relative;
  display: inline-block;
}

.pulseCall::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(45deg, rgba(16, 163, 127, 0.8), rgba(22, 192, 152, 0.6), rgba(16, 163, 127, 0.4));
  transform: translate(-50%, -50%);
  animation: pulseExpand 2s ease-in-out infinite;
  z-index: -1;
}

.pulseCall::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(45deg, rgba(16, 163, 127, 0.6), rgba(22, 192, 152, 0.4), rgba(16, 163, 127, 0.2));
  transform: translate(-50%, -50%);
  animation: pulseExpand 2s ease-in-out infinite 0.5s;
  z-index: -2;
}

@keyframes pulseExpand {
  0% {
    width: 100%;
    height: 100%;
    opacity: 1;
    border-radius: 50%;
  }
  50% {
    width: 200%;
    height: 200%;
    opacity: 0.7;
    border-radius: 50%;
  }
  100% {
    width: 300%;
    height: 300%;
    opacity: 0;
    border-radius: 50%;
  }
} */

/* .profileImageOff {
}

.profileImageOn {
  background: blue;
} */


.profileImageOff_Ca1_G {
  outline: 2px solid #000;

  &.active_ldr9D {
    outline: 2px solid #10a37f;
    border-radius: 24px;
    width: 40px;
    height: 40px;
    animation: pulseGlow_UoNRp 1.5s ease-in-out;

    &:hover {
      outline: 2px solid #000;
      animation: unset !important;
    }

    &::after {
      background: linear-gradient(45deg, rgba(16, 163, 127, 0.8), rgba(239, 68, 68, 0.6), rgba(16, 163, 127, 0.4));
      animation: pulseExpandActive_iV9v9 1.5s ease-in-out;
    }

    &::before {
      background: linear-gradient(45deg, rgba(16, 163, 127, 0.6), rgba(239, 68, 68, 0.4), rgba(16, 163, 127, 0.2));
      animation: pulseExpandActive_iV9v9 1.5s ease-in-out 0.3s;
    }
  }
}

@keyframes pulseExpandActive_iV9v9 {
  0% {
    width: 100%;
    height: 100%;
    opacity: 1;
    border-radius: 50%;
  }

  50% {
    width: 180%;
    height: 180%;
    opacity: 0.8;
    border-radius: 50%;
  }

  100% {
    width: 250%;
    height: 250%;
    opacity: 0;
    border-radius: 50%;
  }
}

@keyframes pulseGlow_UoNRp {

  0%,
  100% {
    box-shadow: 0 0 5px rgba(16, 163, 127, 0.5);
  }

  50% {
    box-shadow: 0 0 20px rgba(16, 163, 127, 0.8), 0 0 30px rgba(16, 163, 127, 0.6);
  }
}


.timeHour_UfmYd {
  margin-top: 4px;
  display: block;
  padding: 1px 4px 2px;
  transition: color 0.3s ease;
  background: #000000;
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: 4px;
  font-size: 8px;
  font-weight: 700;
}

.timeHour_UfmYd.paused_EAzAn {
  background: red;
}

.timeHour_UfmYd {
  margin-top: 4px;
  display: block;
  padding: 1px 4px 2px;
  transition: color 0.3s ease;
  background: #000000;
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: 4px;
  font-size: 8px;
  font-weight: 700;
}

.timeHour_UfmYd.paused_EAzAn {
  background: red;
}








.profileImage_IwxwH {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 5px;
}

.initials_IMyR5 {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--_16c098-background);
  color: var(--white-color);
  font-size: 20px;
  font-weight: 600;
}

.profileText_IHa4Y {
  display: flex;
  flex-direction: column;
  text-align: end;

  p {
    font-size: 15px;
    margin: 0;
  }

  span {
    font-size: 10px;
  }
}

.sidebar_jPRm6 {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100vw;
  max-width: 700px;
  height: 80vh;
  overflow: hidden;
  background-color: var(--white-background);
  z-index: 1000;
  transition:
    right 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  color: var(--black-color);
  scrollbar-width: none;
  /* box-shadow: 6px 0px 44px -24px var(--black-color); */
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);

  @media (width<=950px) {
    height: 100vh;
  }
}

.options_PyeBT {
  position: fixed;
  top: 50px;
  right: 15px;
  background-color: var(--white-background);
  background: var(--white-background);
  border-radius: 8px;
  box-shadow: 0 2px 10px var(--_0000001a-shadow);
  z-index: 3;
  padding: 4px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;

  ul {
    margin: 0;
    display: flex;
    flex-direction: column;
    padding: 0;

    li {
      margin: 0;
      list-style: none;
      display: flex;
      align-items: center;
      gap: 10px;
      color: var(--_3-color);
      box-sizing: border-box;
      width: 100%;
      padding: 8px;
      border: none;
      background: none;
      text-align: left;
      cursor: pointer;
      font-size: 14px;
      border-radius: 4px;
      transition: background-color 0.2s ease-in-out;
      -webkit-transition: background-color 0.2s ease-in-out;
      -moz-transition: background-color 0.2s ease-in-out;
      -ms-transition: background-color 0.2s ease-in-out;
      -o-transition: background-color 0.2s ease-in-out;

      &.upgradePlan_rxnJv {
        background: var(--e4fff9-background);
      }

      &:hover {
        background-color: var(--f5-background);
      }

      svg {
        fill: var(--_0d-color);
        color: var(--_0d-color);
      }
    }
  }
}

.sidebar_jPRm6::-webkit-scrollbar {
  display: none;
}

.show_LnE_x {
  right: 25%;
}



.hiddenMobile_SeGjf {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  /* flex: 1; */
}

.scaleDown_bx8Y7 {
  animation: scaleDown_bx8Y7 300ms ease-in forwards;
  -webkit-animation: scaleDown_bx8Y7 300ms ease-in forwards;
}

@keyframes scaleUp_VrDr9 {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }

  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_bx8Y7 {
  from {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }

  to {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
}

@keyframes gradientShift_r4aUL {
  0% {
    background-position: 0% 50%;
  }

  25% {
    background-position: 100% 50%;
  }

  50% {
    background-position: 100% 100%;
  }

  75% {
    background-position: 0% 100%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.fadeOut_T3XSy {
  opacity: 0;
}

.mobileMenuOverlay_K8MVA {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--_FFFFFF80-background);
  z-index: 998;
}

.mobileMenu_AbnA3 {
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  position: fixed;
  top: 0px;
  right: 0px;
  width: 240px;
  background-color: var(--white-background);
  z-index: 1000;
  height: 100vh;
  padding: 10px;
  border-left: 1px solid var(--f5-border);

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    li,
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }

  .profileContainer_F97zR {
    align-items: flex-end;
  }
}

.deleteChatContent_sHp5S {
  height: calc(30vh - 50px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.deleteChatsContainer_V_dHN {
  width: 80%;
  background-color: var(--white-background);
  margin: 0 auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  p {
    margin: 0;
    color: var(--_38343d-color);
  }

  .password_Ist8I {
    display: flex;
    align-items: center;

    span,
    >div {
      flex: 1 1;
    }

    >div {
      input {
        border: none;
        outline: none;
        font-size: 14px;
        font-weight: 400;
        color: var(--_75-color);
        min-height: 21px;
        background-color: var(--f4-background);
        border-radius: 5px;
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
      }

      span {
        color: var(--b40e1b-color);
        font-size: 13px;
      }
    }
  }
}

@media screen and (width <=950px) {
  .hiddenMobile_SeGjf {
    display: none;
  }

}

@media screen and (width <=1100px) {
  .hiddenTablet_Bc6bp {
    display: none;
  }
}



.bgCurrency_yNnnN {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: var(--_00000033-background);
  z-index: 5;
}

.newCurrencyPopup_YpkeK {
  position: fixed;
  background-color: var(--white-background);
  padding: 10px;
  top: 50%;
  left: 50%;
  z-index: 6;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 70vh;
  overflow-y: scroll;

  .dropdownOption_dh3r9 {
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    color: var(--_9c9d9f-color);
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    transition: background-color 0.2s;
    -webkit-transition: background-color 0.2s;
    -moz-transition: background-color 0.2s;
    -ms-transition: background-color 0.2s;
    -o-transition: background-color 0.2s;

    &:hover {
      background-color: var(--ececf1-background);
    }
  }
}

.pWithTooltip_crtMn {

  text-decoration: none;
  position: relative;


  &:last-child {
    border: none;
  }

  &::before {
    content: attr(data-tooltip);
    position: absolute;
    top: calc(120% + 4px);
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 10px;
    background: var(--_000000cc-background);
    color: var(--white-color);
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;

  }

  &::after {
    content: "";
    position: absolute;
    top: calc(100% - 2px);
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-bottom-color: var(--_000000cc-background);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
  }

  &:hover::before,
  &:hover::after {
    opacity: 1;
    visibility: visible;
  }
}

.timeHour_UfmYd {
  margin-top: 4px;
  display: block;
  padding: 1px 4px 2px;
  transition: color 0.3s ease;
  background: #000000;
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: 4px;
  font-size: 8px;
  font-weight: 700;
}

.timeHour_UfmYd.paused_EAzAn {
  background: red;
}

.notificationTotal_RlF_d {
  position: absolute;
  background-color: var(--_2-color);
  color: var(--white-background);
  padding: 2px 3px;
  border-radius: 6px;
  top: -4px;
  right: -5px;
  font-size: 7px;
}








.workspaceContainer_wnRG0 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;

  /* padding: 10px; */
  /* border-bottom: 1px solid #e0e0e0; */
  >div {
    width: 32px;
    height: 32px;
    min-width: 32px;
    display: flex;
    align-items: center;
    /* margin-left: 6px; */
    border-radius: 8px;
    overflow: hidden;

    svg {
      width: 32px;
      height: 32px;
    }
  }

  b {
    font-size: 16px;
    font-weight: 500;
    color: var(--black-color);
  }

  svg {
    width: 18px;
    height: 18px;
  }
}


.NavbarNews_v2K92 {
  width: 100%;
  height: 48px;
  background: linear-gradient(45deg, #404040 0%, #2a2a2a 25%, #505050 50%, #2a2a2a 75%, #404040 100%);
  background-size: 400% 400%;
  animation: gradientShift_r4aUL 8s ease-in-out infinite;

  .close_C30by {
    display: none;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #ececf121;
    position: absolute;
    top: 7px;
    right: 15px;
    cursor: pointer;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #ececf140;
    }
  }

  &:hover {
    .close_C30by {
      display: flex;
    }
  }
}

.NavarSearchExpand_MYIV3 {
  .NavarSearchExpandInput_CVKeS {
    display: flex;
    align-items: center;
    gap: 6px;
    background: var(--white-background);
    border-radius: 8px;
    padding: 6px 6px;
    border: 1px solid var(--ececf1-border);
    min-width: 300px;
    transition: all 0.3s ease;

    svg {
      width: 20px;
      height: 20px;
    }

    input {
      border: none;
      outline: none;
      background: transparent;
      font-size: 14px;
      font-weight: 400;
      color: var(--black-color);
    }

    >div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
      border-radius: 5px;
      background: var(--f5-background);
      color: #8f8686;
      font-size: 10px;
    }

    &.isFocus_zpIJ9 {
      border: 1px solid var(--_000000cc-background);
      background: var(--black-color);

      input {
        color: var(--white-color);
      }

      >div {
        background: var(--1e293b-color);
        color: var(--white-color);
      }
    }
  }

  .NavarSearchExpandList_TbBRk {
    padding: 4px;
    background: var(--white-background);
    border-radius: 8px;
    border: none;
    position: absolute;
    width: 100%;
    max-width: 420px;
    margin-top: 2px;
    box-shadow: 0px 2px 12px -10px black;
    display: inline-flex;
    flex-direction: column;
    gap: 10px;

    >ul {
      padding: 0px;
      margin: 0px;
      overflow-y: scroll;
      max-height: 500px;
      width: 100%;
      display: inline-flex;
      flex-direction: column;
      gap: 4px;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .NavarSearchExpandItem_lT5L3 {
      display: flex;
      align-items: center;
      gap: 10px;
      border-radius: 8px;
      /* border: 1px solid var(--ececf1-border); */

      .NavarSearchExpandItemContent_NvQHt {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 6px;
        border-radius: 8px;
        border: 1px solid var(--f5-border);
        background: var(--fa-background);
        cursor: pointer;

        &:hover {
          background: var(--white-color);
        }

        .NavarSearchExpandItemIcon_JmDxh {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 45px;
          min-width: 45px;
          height: 45px;
          background: var(--f5-background);
          border-radius: 10px;
        }

        .NavarSearchExpandItemContentText_IkiyG {
          display: flex;
          flex-direction: column;
          gap: 4px;
          border-radius: 8px;
          width: 100%;
          margin: 0px;

          .NavarSearchExpandItemContentTextTitle_aaQVN {
            font-size: 14px;
            font-weight: 500;
            color: var(--black-color);
          }

          .NavarSearchExpandItemContentTextDescription_egfvh {
            font-size: 12px;
            font-weight: 400;
            color: var(--black-color);
            margin: 0px;
          }
        }
      }
    }

    /* No results found styling */
    .NavarSearchExpandItem_lT5L3:has(.NavarSearchExpandItemContentTextDescription_egfvh:only-child) {
      .NavarSearchExpandItemContent_NvQHt {
        justify-content: center;
        padding: 20px;
        background: var(--f5-background);
        border: 1px dashed var(--ececf1-border);

        .NavarSearchExpandItemContentTextDescription_egfvh {
          text-align: center;
          color: var(--818181-color);
          font-style: italic;
        }
      }
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NavbarAdmin/NavbarAdmin.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,MAAM;EACN,QAAQ;EACR,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;;EAEZ;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;IAChC,2BAA2B;IAC3B,yBAAyB;;IAEzB;MACE,iBAAiB;IACnB;;IAEA;MACE,gCAAgC;MAChC,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;MACzB,iBAAiB;IACnB;EACF;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;;;IAGlB;MACE,YAAY;IACd;;IAEA;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,qBAAqB;MACrB,SAAS;MACT,2BAA2B;MAC3B,iBAAiB;MACjB,uCAAuC;MACvC,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,mBAAmB;MACnB,UAAU;MACV,kBAAkB;MAClB,yBAAyB;;IAE3B;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,qBAAqB;MACrB,SAAS;MACT,2BAA2B;MAC3B,6BAA6B;MAC7B,gDAAgD;MAChD,UAAU;MACV,kBAAkB;MAClB,yBAAyB;IAC3B;;IAEA;;MAEE,UAAU;MACV,mBAAmB;IACrB;;EAEF;;EAEA;;IAEE,wBAAwB;IACxB,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX;;;;yBAIqB;IACrB,0BAA0B;IAC1B,gDAA0C;IAC1C,YAAY;IACZ,wDAAkD;;IAElD;MACE,cAAc;IAChB;EACF;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;;AAErB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;;EAErB;IACE,qBAAqB;EACvB;AACF;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,aAAa;;EAEb;IACE,kBAAkB;;;EAGpB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,oCAAoC;MACpC,kBAAkB;IACpB;;IAEA;MACE,wBAAwB;MACxB,yBAAyB;IAC3B;;IAEA;MACE;QACE,+BAA+B;MACjC;IACF;EACF;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;;AAGF;;;;;AAKA,oCAAoC;AACpC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAoDG;;AAEH;;;;;GAKG;;;AAGH;EACE,uBAAuB;;EAEvB;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,2CAAqC;;IAErC;MACE,uBAAuB;MACvB,2BAA2B;IAC7B;;IAEA;MACE,4GAA4G;MAC5G,mDAA6C;IAC/C;;IAEA;MACE,4GAA4G;MAC5G,wDAAkD;IACpD;EACF;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;;EAEE;;IAEE,2CAA2C;EAC7C;;EAEA;IACE,8EAA8E;EAChF;AACF;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;;;;;;;;AASA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;;EAEf;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb;;4BAE0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,uDAAuD;EACvD,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;;EAEnC;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,mCAAmC;EACnC,kBAAkB;EAClB,8CAA8C;EAC9C,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;;EAErB;IACE,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,UAAU;;IAEV;MACE,SAAS;MACT,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,sBAAsB;MACtB,sBAAsB;MACtB,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,gBAAgB;MAChB,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,6CAA6C;MAC7C,qDAAqD;MACrD,kDAAkD;MAClD,iDAAiD;MACjD,gDAAgD;;MAEhD;QACE,oCAAoC;MACtC;;MAEA;QACE,sCAAsC;MACxC;;MAEA;QACE,sBAAsB;QACtB,uBAAuB;MACzB;IACF;EACF;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;;;AAIA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;;EAEA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;;EAEA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,aAAa;EACb,uCAAuC;;EAEvC;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET;;MAEE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;;MAET;QACE,WAAW;QACX,YAAY;MACd;IACF;EACF;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,yCAAyC;EACzC,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;;IAEnB;;MAEE,SAAO;IACT;;IAEA;MACE;QACE,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,gBAAgB;QAChB,sCAAsC;QACtC,kBAAkB;QAClB,sBAAsB;QACtB,WAAW;QACX,aAAa;MACf;;MAEA;QACE,0BAA0B;QAC1B,eAAe;MACjB;IACF;EACF;AACF;;AAEA;EACE;IACE,aAAa;EACf;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;;;AAIA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,MAAM;EACN,OAAO;EACP,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;;EAElB;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iCAAiC;IACjC,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;;IAEpC;MACE,0CAA0C;IAC5C;EACF;AACF;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;;;EAGlB;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,uCAAuC;IACvC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;;EAE3B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,6BAA6B;IAC7B,gDAAgD;IAChD,UAAU;IACV,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;;IAEE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;;;;;;;;AASA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,WAAW;;EAEX,mBAAmB;EACnB,sCAAsC;EACtC;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;;IAEhB;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,mGAAmG;EACnG,0BAA0B;EAC1B,sDAAgD;;EAEhD;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;IAChB,yBAAyB;;IAEzB;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,eAAe;MACf,gBAAgB;MAChB,yBAAyB;IAC3B;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,eAAe;MACf,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,gCAAgC;MAChC,cAAc;MACd,eAAe;IACjB;;IAEA;MACE,6CAA6C;MAC7C,8BAA8B;;MAE9B;QACE,yBAAyB;MAC3B;;MAEA;QACE,+BAA+B;QAC/B,yBAAyB;MAC3B;IACF;EACF;;EAEA;IACE,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,oCAAoC;IACpC,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;;IAET;MACE,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,iBAAiB;MACjB,WAAW;MACX,oBAAoB;MACpB,sBAAsB;MACtB,QAAQ;;MAER;QACE,aAAa;MACf;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,kBAAkB;MAClB,4CAA4C;;MAE5C;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kCAAkC;QAClC,gCAAgC;QAChC,eAAe;;QAEf;UACE,8BAA8B;QAChC;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,WAAW;UACX,eAAe;UACf,YAAY;UACZ,gCAAgC;UAChC,mBAAmB;QACrB;;QAEA;UACE,aAAa;UACb,sBAAsB;UACtB,QAAQ;UACR,kBAAkB;UAClB,WAAW;UACX,WAAW;;UAEX;YACE,eAAe;YACf,gBAAgB;YAChB,yBAAyB;UAC3B;;UAEA;YACE,eAAe;YACf,gBAAgB;YAChB,yBAAyB;YACzB,WAAW;UACb;QACF;MACF;IACF;;IAEA,6BAA6B;IAC7B;MACE;QACE,uBAAuB;QACvB,aAAa;QACb,gCAAgC;QAChC,uCAAuC;;QAEvC;UACE,kBAAkB;UAClB,0BAA0B;UAC1B,kBAAkB;QACpB;MACF;IACF;EACF;AACF","sourcesContent":[".none {\n  display: none;\n}\n\n.settingsBg {\n  height: 100vh;\n  width: 100vw;\n  background-color: transparent;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n}\n\n@media (width >=950px) {\n  .MenuMobileIcon {\n    display: none;\n  }\n}\n\n.shortcut {\n  font-size: 12px;\n  background-color: var(--ececf1-background);\n  border-radius: 4px;\n  padding: 4px 6px;\n  color: var(--818181-color);\n  font-weight: 400;\n  margin-left: auto;\n  margin-right: 14px;\n  right: -10px;\n  position: relative;\n}\n\n.navbarAdmin {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  z-index: 3;\n  /* position: sticky; */\n  top: 0;\n  gap: 6px;\n  background: var(--f5-background);\n  color: var(--black-color);\n  font-size: 13px;\n  padding: 10px 8px;\n  box-sizing: border-box;\n  height: 50px;\n\n  .name {\n    display: flex;\n    align-items: center;\n    font-size: 25px;\n    text-transform: capitalize;\n    font-weight: 400;\n    font-family: \"Inter\", sans-serif;\n    backdrop-filter: blur(10px);\n    color: var(--black-color);\n\n    img {\n      margin-right: 4px;\n    }\n\n    span {\n      font-family: \"Inter\", sans-serif;\n      text-transform: uppercase;\n    }\n\n    svg {\n      color: var(--black-color);\n      margin-right: 4px;\n    }\n  }\n\n  a {\n    text-decoration: none;\n    position: relative;\n\n\n    &:last-child {\n      border: none;\n    }\n\n    &::before {\n      content: attr(data-tooltip);\n      position: absolute;\n      top: calc(120% + 1px);\n      left: 50%;\n      transform: translateX(-50%);\n      padding: 5px 10px;\n      background: var(--_000000cc-background);\n      color: var(--white-color);\n      border-radius: 4px;\n      font-size: 12px;\n      white-space: nowrap;\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.3s ease;\n\n    }\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: calc(100% - 1px);\n      left: 50%;\n      transform: translateX(-50%);\n      border: 5px solid transparent;\n      border-bottom-color: var(--_000000cc-background);\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.3s ease;\n    }\n\n    &:hover::before,\n    &:hover::after {\n      opacity: 1;\n      visibility: visible;\n    }\n\n  }\n\n  .noTooltip::before,\n  .noTooltip::after {\n    display: none !important;\n    content: none !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n  }\n\n  .loading {\n    display: none;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 3px;\n    background: linear-gradient(90deg,\n        transparent 0%,\n        var(--_16c098-background) 25%,\n        var(--_16c098-background) 75%,\n        transparent 100%);\n    background-size: 200% 100%;\n    animation: loading 2s infinite ease-in-out;\n    opacity: 0.8;\n    -webkit-animation: loading 2s infinite ease-in-out;\n\n    &.active {\n      display: block;\n    }\n  }\n}\n\n@keyframes loading {\n  0% {\n    background-position: -200% 0;\n  }\n\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n.navbarAdminIcons {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  /* flex: 1; */\n}\n\n@media (width <=950px) {\n  .navbarAdminIcons {\n    justify-content: space-between;\n  }\n}\n\n.plus {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--_10a37f-background);\n  outline: none;\n  border: none;\n  cursor: pointer;\n  background: var(--_16c0982e-background);\n  font-weight: 550;\n  padding: 5px 10px;\n  border-radius: 16px;\n  line-height: 12px;\n  border: 1px solid var(--_16c098-background);\n  white-space: nowrap;\n\n}\n\n.profileContainer {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: 8px;\n}\n\n.addIcon {\n  height: 18px;\n  width: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n\n  svg {\n    fill: rgb(53, 55, 64);\n  }\n}\n\n\n\n.profile {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: end;\n  /* flex: 1; */\n\n  .number {\n    position: relative;\n\n\n  }\n\n  a {\n    cursor: pointer;\n    position: relative;\n    width: 34px;\n    height: 34px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover {\n      background: var(--ececf1-background);\n      border-radius: 50%;\n    }\n\n    svg {\n      fill: var(--black-color);\n      color: var(--black-color);\n    }\n\n    &.active {\n      svg {\n        fill: var(--_16c098-background);\n      }\n    }\n  }\n\n  img {\n    width: 20px;\n    border-radius: 50%;\n  }\n\n\n}\n\n\n\n\n/* Animación de pulso para llamada */\n/* .pulseCall {\n  position: relative;\n  display: inline-block;\n}\n\n.pulseCall::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: linear-gradient(45deg, rgba(16, 163, 127, 0.8), rgba(22, 192, 152, 0.6), rgba(16, 163, 127, 0.4));\n  transform: translate(-50%, -50%);\n  animation: pulseExpand 2s ease-in-out infinite;\n  z-index: -1;\n}\n\n.pulseCall::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: linear-gradient(45deg, rgba(16, 163, 127, 0.6), rgba(22, 192, 152, 0.4), rgba(16, 163, 127, 0.2));\n  transform: translate(-50%, -50%);\n  animation: pulseExpand 2s ease-in-out infinite 0.5s;\n  z-index: -2;\n}\n\n@keyframes pulseExpand {\n  0% {\n    width: 100%;\n    height: 100%;\n    opacity: 1;\n    border-radius: 50%;\n  }\n  50% {\n    width: 200%;\n    height: 200%;\n    opacity: 0.7;\n    border-radius: 50%;\n  }\n  100% {\n    width: 300%;\n    height: 300%;\n    opacity: 0;\n    border-radius: 50%;\n  }\n} */\n\n/* .profileImageOff {\n}\n\n.profileImageOn {\n  background: blue;\n} */\n\n\n.profileImageOff {\n  outline: 2px solid #000;\n\n  &.active {\n    outline: 2px solid #10a37f;\n    border-radius: 24px;\n    width: 40px;\n    height: 40px;\n    animation: pulseGlow 1.5s ease-in-out;\n\n    &:hover {\n      outline: 2px solid #000;\n      animation: unset !important;\n    }\n\n    &::after {\n      background: linear-gradient(45deg, rgba(16, 163, 127, 0.8), rgba(239, 68, 68, 0.6), rgba(16, 163, 127, 0.4));\n      animation: pulseExpandActive 1.5s ease-in-out;\n    }\n\n    &::before {\n      background: linear-gradient(45deg, rgba(16, 163, 127, 0.6), rgba(239, 68, 68, 0.4), rgba(16, 163, 127, 0.2));\n      animation: pulseExpandActive 1.5s ease-in-out 0.3s;\n    }\n  }\n}\n\n@keyframes pulseExpandActive {\n  0% {\n    width: 100%;\n    height: 100%;\n    opacity: 1;\n    border-radius: 50%;\n  }\n\n  50% {\n    width: 180%;\n    height: 180%;\n    opacity: 0.8;\n    border-radius: 50%;\n  }\n\n  100% {\n    width: 250%;\n    height: 250%;\n    opacity: 0;\n    border-radius: 50%;\n  }\n}\n\n@keyframes pulseGlow {\n\n  0%,\n  100% {\n    box-shadow: 0 0 5px rgba(16, 163, 127, 0.5);\n  }\n\n  50% {\n    box-shadow: 0 0 20px rgba(16, 163, 127, 0.8), 0 0 30px rgba(16, 163, 127, 0.6);\n  }\n}\n\n\n.timeHour {\n  margin-top: 4px;\n  display: block;\n  padding: 1px 4px 2px;\n  transition: color 0.3s ease;\n  background: #000000;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  border-radius: 4px;\n  font-size: 8px;\n  font-weight: 700;\n}\n\n.timeHour.paused {\n  background: red;\n}\n\n.timeHour {\n  margin-top: 4px;\n  display: block;\n  padding: 1px 4px 2px;\n  transition: color 0.3s ease;\n  background: #000000;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  border-radius: 4px;\n  font-size: 8px;\n  font-weight: 700;\n}\n\n.timeHour.paused {\n  background: red;\n}\n\n\n\n\n\n\n\n\n.profileImage {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  border-radius: 5px;\n}\n\n.initials {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--_16c098-background);\n  color: var(--white-color);\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.profileText {\n  display: flex;\n  flex-direction: column;\n  text-align: end;\n\n  p {\n    font-size: 15px;\n    margin: 0;\n  }\n\n  span {\n    font-size: 10px;\n  }\n}\n\n.sidebar {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 100vw;\n  max-width: 700px;\n  height: 80vh;\n  overflow: hidden;\n  background-color: var(--white-background);\n  z-index: 1000;\n  transition:\n    right 0.3s ease-in-out,\n    opacity 0.3s ease-in-out;\n  color: var(--black-color);\n  scrollbar-width: none;\n  /* box-shadow: 6px 0px 44px -24px var(--black-color); */\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n\n  @media (width<=950px) {\n    height: 100vh;\n  }\n}\n\n.options {\n  position: fixed;\n  top: 50px;\n  right: 15px;\n  background-color: var(--white-background);\n  background: var(--white-background);\n  border-radius: 8px;\n  box-shadow: 0 2px 10px var(--_0000001a-shadow);\n  z-index: 3;\n  padding: 4px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n\n  ul {\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n\n    li {\n      margin: 0;\n      list-style: none;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      color: var(--_3-color);\n      box-sizing: border-box;\n      width: 100%;\n      padding: 8px;\n      border: none;\n      background: none;\n      text-align: left;\n      cursor: pointer;\n      font-size: 14px;\n      border-radius: 4px;\n      transition: background-color 0.2s ease-in-out;\n      -webkit-transition: background-color 0.2s ease-in-out;\n      -moz-transition: background-color 0.2s ease-in-out;\n      -ms-transition: background-color 0.2s ease-in-out;\n      -o-transition: background-color 0.2s ease-in-out;\n\n      &.upgradePlan {\n        background: var(--e4fff9-background);\n      }\n\n      &:hover {\n        background-color: var(--f5-background);\n      }\n\n      svg {\n        fill: var(--_0d-color);\n        color: var(--_0d-color);\n      }\n    }\n  }\n}\n\n.sidebar::-webkit-scrollbar {\n  display: none;\n}\n\n.show {\n  right: 25%;\n}\n\n\n\n.hiddenMobile {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n  /* flex: 1; */\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n\n  to {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n@keyframes gradientShift {\n  0% {\n    background-position: 0% 50%;\n  }\n\n  25% {\n    background-position: 100% 50%;\n  }\n\n  50% {\n    background-position: 100% 100%;\n  }\n\n  75% {\n    background-position: 0% 100%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n.mobileMenuOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--_FFFFFF80-background);\n  z-index: 998;\n}\n\n.mobileMenu {\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 10px;\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  width: 240px;\n  background-color: var(--white-background);\n  z-index: 1000;\n  height: 100vh;\n  padding: 10px;\n  border-left: 1px solid var(--f5-border);\n\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n    li,\n    a {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n\n      svg {\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  .profileContainer {\n    align-items: flex-end;\n  }\n}\n\n.deleteChatContent {\n  height: calc(30vh - 50px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.deleteChatsContainer {\n  width: 80%;\n  background-color: var(--white-background);\n  margin: 0 auto;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  p {\n    margin: 0;\n    color: var(--_38343d-color);\n  }\n\n  .password {\n    display: flex;\n    align-items: center;\n\n    span,\n    >div {\n      flex: 1;\n    }\n\n    >div {\n      input {\n        border: none;\n        outline: none;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--_75-color);\n        min-height: 21px;\n        background-color: var(--f4-background);\n        border-radius: 5px;\n        box-sizing: border-box;\n        width: 100%;\n        padding: 12px;\n      }\n\n      span {\n        color: var(--b40e1b-color);\n        font-size: 13px;\n      }\n    }\n  }\n}\n\n@media screen and (width <=950px) {\n  .hiddenMobile {\n    display: none;\n  }\n\n}\n\n@media screen and (width <=1100px) {\n  .hiddenTablet {\n    display: none;\n  }\n}\n\n\n\n.bgCurrency {\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  background-color: var(--_00000033-background);\n  z-index: 5;\n}\n\n.newCurrencyPopup {\n  position: fixed;\n  background-color: var(--white-background);\n  padding: 10px;\n  top: 50%;\n  left: 50%;\n  z-index: 6;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 70vh;\n  overflow-y: scroll;\n\n  .dropdownOption {\n    padding: 8px 12px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--_9c9d9f-color);\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    -webkit-transition: background-color 0.2s;\n    -moz-transition: background-color 0.2s;\n    -ms-transition: background-color 0.2s;\n    -o-transition: background-color 0.2s;\n\n    &:hover {\n      background-color: var(--ececf1-background);\n    }\n  }\n}\n\n.pWithTooltip {\n\n  text-decoration: none;\n  position: relative;\n\n\n  &:last-child {\n    border: none;\n  }\n\n  &::before {\n    content: attr(data-tooltip);\n    position: absolute;\n    top: calc(120% + 4px);\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 5px 10px;\n    background: var(--_000000cc-background);\n    color: var(--white-color);\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: nowrap;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n\n  }\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: calc(100% - 2px);\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-bottom-color: var(--_000000cc-background);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n  }\n\n  &:hover::before,\n  &:hover::after {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.timeHour {\n  margin-top: 4px;\n  display: block;\n  padding: 1px 4px 2px;\n  transition: color 0.3s ease;\n  background: #000000;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  border-radius: 4px;\n  font-size: 8px;\n  font-weight: 700;\n}\n\n.timeHour.paused {\n  background: red;\n}\n\n.notificationTotal {\n  position: absolute;\n  background-color: var(--_2-color);\n  color: var(--white-background);\n  padding: 2px 3px;\n  border-radius: 6px;\n  top: -4px;\n  right: -5px;\n  font-size: 7px;\n}\n\n\n\n\n\n\n\n\n.workspaceContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  width: 100%;\n\n  /* padding: 10px; */\n  /* border-bottom: 1px solid #e0e0e0; */\n  >div {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    display: flex;\n    align-items: center;\n    /* margin-left: 6px; */\n    border-radius: 8px;\n    overflow: hidden;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  b {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--black-color);\n  }\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n\n.NavbarNews {\n  width: 100%;\n  height: 48px;\n  background: linear-gradient(45deg, #404040 0%, #2a2a2a 25%, #505050 50%, #2a2a2a 75%, #404040 100%);\n  background-size: 400% 400%;\n  animation: gradientShift 8s ease-in-out infinite;\n\n  .close {\n    display: none;\n    width: 26px;\n    height: 26px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    background: #ececf121;\n    position: absolute;\n    top: 7px;\n    right: 15px;\n    cursor: pointer;\n    align-items: center;\n    justify-content: center;\n\n    &:hover {\n      background: #ececf140;\n    }\n  }\n\n  &:hover {\n    .close {\n      display: flex;\n    }\n  }\n}\n\n.NavarSearchExpand {\n  .NavarSearchExpandInput {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: var(--white-background);\n    border-radius: 8px;\n    padding: 6px 6px;\n    border: 1px solid var(--ececf1-border);\n    min-width: 300px;\n    transition: all 0.3s ease;\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n\n    input {\n      border: none;\n      outline: none;\n      background: transparent;\n      font-size: 14px;\n      font-weight: 400;\n      color: var(--black-color);\n    }\n\n    >div {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 20px;\n      min-width: 20px;\n      height: 20px;\n      min-height: 20px;\n      border-radius: 5px;\n      background: var(--f5-background);\n      color: #8f8686;\n      font-size: 10px;\n    }\n\n    &.isFocus {\n      border: 1px solid var(--_000000cc-background);\n      background: var(--black-color);\n\n      input {\n        color: var(--white-color);\n      }\n\n      >div {\n        background: var(--1e293b-color);\n        color: var(--white-color);\n      }\n    }\n  }\n\n  .NavarSearchExpandList {\n    padding: 4px;\n    background: var(--white-background);\n    border-radius: 8px;\n    border: none;\n    position: absolute;\n    width: 100%;\n    max-width: 420px;\n    margin-top: 2px;\n    box-shadow: 0px 2px 12px -10px black;\n    display: inline-flex;\n    flex-direction: column;\n    gap: 10px;\n\n    >ul {\n      padding: 0px;\n      margin: 0px;\n      overflow-y: scroll;\n      max-height: 500px;\n      width: 100%;\n      display: inline-flex;\n      flex-direction: column;\n      gap: 4px;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n\n    .NavarSearchExpandItem {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      border-radius: 8px;\n      /* border: 1px solid var(--ececf1-border); */\n\n      .NavarSearchExpandItemContent {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        width: 100%;\n        padding: 6px;\n        border-radius: 8px;\n        border: 1px solid var(--f5-border);\n        background: var(--fa-background);\n        cursor: pointer;\n\n        &:hover {\n          background: var(--white-color);\n        }\n\n        .NavarSearchExpandItemIcon {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 45px;\n          min-width: 45px;\n          height: 45px;\n          background: var(--f5-background);\n          border-radius: 10px;\n        }\n\n        .NavarSearchExpandItemContentText {\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n          border-radius: 8px;\n          width: 100%;\n          margin: 0px;\n\n          .NavarSearchExpandItemContentTextTitle {\n            font-size: 14px;\n            font-weight: 500;\n            color: var(--black-color);\n          }\n\n          .NavarSearchExpandItemContentTextDescription {\n            font-size: 12px;\n            font-weight: 400;\n            color: var(--black-color);\n            margin: 0px;\n          }\n        }\n      }\n    }\n\n    /* No results found styling */\n    .NavarSearchExpandItem:has(.NavarSearchExpandItemContentTextDescription:only-child) {\n      .NavarSearchExpandItemContent {\n        justify-content: center;\n        padding: 20px;\n        background: var(--f5-background);\n        border: 1px dashed var(--ececf1-border);\n\n        .NavarSearchExpandItemContentTextDescription {\n          text-align: center;\n          color: var(--818181-color);\n          font-style: italic;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"none": `none_eyrvQ`,
	"settingsBg": `settingsBg_He7I9`,
	"MenuMobileIcon": `MenuMobileIcon_A9WAh`,
	"shortcut": `shortcut_uSreM`,
	"navbarAdmin": `navbarAdmin_mTHm7`,
	"loading": `loading_u_fYb`,
	"name": `name_avW4i`,
	"noTooltip": `noTooltip_Ot6Rv`,
	"active": `active_ldr9D`,
	"navbarAdminIcons": `navbarAdminIcons_FOHC3`,
	"plus": `plus_v0gVD`,
	"profileContainer": `profileContainer_F97zR`,
	"addIcon": `addIcon_zzoTw`,
	"profile": `profile_E110D`,
	"number": `number_EcOt0`,
	"profileImageOff": `profileImageOff_Ca1_G`,
	"pulseGlow": `pulseGlow_UoNRp`,
	"pulseExpandActive": `pulseExpandActive_iV9v9`,
	"timeHour": `timeHour_UfmYd`,
	"paused": `paused_EAzAn`,
	"profileImage": `profileImage_IwxwH`,
	"initials": `initials_IMyR5`,
	"profileText": `profileText_IHa4Y`,
	"sidebar": `sidebar_jPRm6`,
	"options": `options_PyeBT`,
	"upgradePlan": `upgradePlan_rxnJv`,
	"show": `show_LnE_x`,
	"hiddenMobile": `hiddenMobile_SeGjf`,
	"scaleDown": `scaleDown_bx8Y7`,
	"fadeOut": `fadeOut_T3XSy`,
	"mobileMenuOverlay": `mobileMenuOverlay_K8MVA`,
	"mobileMenu": `mobileMenu_AbnA3`,
	"deleteChatContent": `deleteChatContent_sHp5S`,
	"deleteChatsContainer": `deleteChatsContainer_V_dHN`,
	"password": `password_Ist8I`,
	"hiddenTablet": `hiddenTablet_Bc6bp`,
	"bgCurrency": `bgCurrency_yNnnN`,
	"newCurrencyPopup": `newCurrencyPopup_YpkeK`,
	"dropdownOption": `dropdownOption_dh3r9`,
	"pWithTooltip": `pWithTooltip_crtMn`,
	"notificationTotal": `notificationTotal_RlF_d`,
	"workspaceContainer": `workspaceContainer_wnRG0`,
	"NavbarNews": `NavbarNews_v2K92`,
	"gradientShift": `gradientShift_r4aUL`,
	"close": `close_C30by`,
	"NavarSearchExpand": `NavarSearchExpand_MYIV3`,
	"NavarSearchExpandInput": `NavarSearchExpandInput_CVKeS`,
	"isFocus": `isFocus_zpIJ9`,
	"NavarSearchExpandList": `NavarSearchExpandList_TbBRk`,
	"NavarSearchExpandItem": `NavarSearchExpandItem_lT5L3`,
	"NavarSearchExpandItemContent": `NavarSearchExpandItemContent_NvQHt`,
	"NavarSearchExpandItemIcon": `NavarSearchExpandItemIcon_JmDxh`,
	"NavarSearchExpandItemContentText": `NavarSearchExpandItemContentText_IkiyG`,
	"NavarSearchExpandItemContentTextTitle": `NavarSearchExpandItemContentTextTitle_aaQVN`,
	"NavarSearchExpandItemContentTextDescription": `NavarSearchExpandItemContentTextDescription_egfvh`,
	"scaleUp": `scaleUp_VrDr9`
};
export default ___CSS_LOADER_EXPORT___;
